module.exports = System.import('@enersis/gp-components/store');